import { IBaseBlockShowResource, Id, RenderView } from "@dgs/core";
import { useFormikContext } from "formik";
import { FC } from "react";
import { ActionTypes } from "../shared/types/actions";
import { useRegistrationForm } from "./provider/registrationFormProviderContext";
import { flattenStepDataFields } from "./registrationFormUtils";
import { areAllRulesValid } from "./rules/ruleSets/ruleSet";

interface Props {
	block: IBaseBlockShowResource;
	sectionId?: Id;
}

export const BlockRenderer: FC<Props> = ({ block, sectionId = null }) => {
	const { values } = useFormikContext<Record<number, any>>();
	const { registrationForm, filledSteps } = useRegistrationForm();
	const dataFieldValues = {
		...flattenStepDataFields(filledSteps),
		...values,
	};
	const ruleSet = registrationForm.ruleSets.find((r) =>
		r.actions.find(
			(a) => a.type === ActionTypes.SHOW_BLOCK && a.value.id === block.id && a.value.sectionId === sectionId,
		),
	);

	if (
		!ruleSet ||
		areAllRulesValid(ruleSet, dataFieldValues, registrationForm.guest, filledSteps, registrationForm.steps)
	) {
		return <RenderView block={block} />;
	}

	return null;
};
